export default "__VITE_ASSET__ea67720e__"